import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';
import { addDays, startOfDay } from 'date-fns';
import type { StepDirection } from './types';

const DAY_VIEW_OPTIONS = [1, 2, 3, 4, 5, 6, 7];

interface GridViewControlsProps {
  dayView: number;
  onDayViewChange: (days: number) => void;
}

export function GridViewControls({ dayView, onDayViewChange }: GridViewControlsProps) {
  return (
    <Select value={dayView.toString()} onValueChange={(value) => onDayViewChange(parseInt(value))}>
      <SelectTrigger className="w-[140px] bg-background border-border text-foreground h-8">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-popover border-border">
        {DAY_VIEW_OPTIONS.map((days) => (
          <SelectItem key={days} value={days.toString()}>
            {days} {days === 1 ? 'day' : 'days'}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function gridRangeStart(cursor: Date): Date {
  return startOfDay(cursor);
}

export function gridStepDate(cursor: Date, direction: StepDirection, dayView: number): Date {
  return addDays(cursor, direction * dayView);
}
